import { ApplicationEntity } from "@/model/entity/application-entity"
import { Office } from "@/model/entity/office/office"
import { MasterRange } from "@/model/entity/range/master-range"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"
import { Expose } from "class-transformer"

export class RangeOffice extends ApplicationEntity {

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.address.upload.report.company",
    isFilterable: true
  })
  get company(): string | undefined {
    if (exists(this._office)) {
      return this._office!.company!.name
    }
    return undefined
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.address.upload.report.office",
    isFilterable: true
  })
  get office(): string | undefined {
    if (exists(this._office)) {
      return this._office!.officeName
    }
    return undefined
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "user_administration.company_dsw_code",
    isFilterable: true
  })
  get dsw(): string | undefined {
    if (exists(this._office) && exists(this._office!.company)) {
      return this._office!.company!.dswCode
    }
    return undefined
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "user_administration.company.city",
    isFilterable: true
  })
  get city(): string | undefined {
    if (exists(this._office)) {
      return this._office!.officeCity
    }
    return undefined
  }

  @Expose({ name: "office" })
  public _office?: Office

  public range?: MasterRange

  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.range.active" })
  public active: boolean

  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.start" })
  public rangeStart: number

  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.end" })
  public rangeEnd: number

  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.next" })
  public rangeNext: number

  @FieldDescriptor({ fieldType: FieldTypeEnum.NUMBER, fieldPrettyName: "entity.range.available" })
  available: number

  public insertDate: Date

  constructor(
    id?: number,
    office?: Office,
    active: boolean = false,
    rangeStart: number = 0,
    rangeEnd: number = 0,
    rangeNext: number = 0,
    insertDate: Date = new Date()
  ) {
    super(id)
    this._office = office
    this.active = active
    this.rangeStart = rangeStart
    this.rangeEnd = rangeEnd
    this.rangeNext = rangeNext
    this.insertDate = insertDate
    this.available = rangeEnd - rangeNext
  }
}
